// Estado sticky do header (transparente/branco no topo → card branco flutuante)
// e navegação de painéis do mega menu lateral (#mk-drawer).

const header = document.getElementById('header-component');

if (header) {
  let ticking = false;

  // No Horizon quem rola é o .page-wrapper (o html fica overflow:hidden),
  // então lemos o scroll de qualquer contêiner possível.
  const pageWrapper = document.querySelector('.page-wrapper');

  const scrollTop = () =>
    Math.max(
      window.scrollY || 0,
      document.scrollingElement ? document.scrollingElement.scrollTop : 0,
      document.body.scrollTop || 0,
      pageWrapper ? pageWrapper.scrollTop : 0
    );

  const update = () => {
    header.dataset.state = scrollTop() > 16 ? 'stuck' : 'top';
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  // capture: true pega o scroll de qualquer elemento, inclusive .page-wrapper
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('scroll', onScroll, { passive: true });

  update();
}

const categoriesMenu = document.querySelector('.mk-hd__categories');

if (categoriesMenu) {
  const trigger = categoriesMenu.querySelector('.mk-hd__categories-trigger');
  const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  let closeTimer = 0;

  const setOpen = (open) => {
    clearTimeout(closeTimer);
    categoriesMenu.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => setOpen(false), 140);
  };

  trigger?.addEventListener('click', () => {
    setOpen(!categoriesMenu.classList.contains('is-open'));
  });

  categoriesMenu.addEventListener('pointerenter', () => {
    if (canHover.matches) setOpen(true);
  });

  categoriesMenu.addEventListener('pointerleave', () => {
    if (canHover.matches) scheduleClose();
  });

  categoriesMenu.addEventListener('focusout', (event) => {
    if (!categoriesMenu.contains(event.relatedTarget)) setOpen(false);
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Node && !categoriesMenu.contains(event.target)) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
}

const drawer = document.getElementById('mk-drawer');

if (drawer) {
  const dialog = drawer.querySelector('dialog');
  const cats = drawer.querySelectorAll('[data-mk-cat]');
  const panels = drawer.querySelectorAll('[data-mk-panel]');
  const desktop = window.matchMedia('(min-width: 990px)');

  const closeSub = () => {
    dialog?.classList.remove('mk-dw--sub');
    panels.forEach((p) => { p.hidden = true; });
    cats.forEach((c) => {
      c.classList.remove('is-active');
      c.setAttribute('aria-expanded', 'false');
    });
  };

  const openSub = (btn) => {
    const id = btn.dataset.mkCat;
    panels.forEach((p) => { p.hidden = p.dataset.mkPanel !== id; });
    cats.forEach((c) => {
      const on = c === btn;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    dialog?.classList.add('mk-dw--sub');
  };

  cats.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-active') && desktop.matches) {
        closeSub();
      } else {
        openSub(btn);
      }
    });

    // Desktop: hover também abre o painel, estilo L'Occitane
    btn.addEventListener('pointerenter', () => {
      if (desktop.matches) openSub(btn);
    });
  });

  drawer.querySelectorAll('[data-mk-back]').forEach((b) => {
    b.addEventListener('click', closeSub);
  });

  dialog?.addEventListener('close', closeSub);
}
